import {RecurringType, Frequency} from "../enums/enums";

export const recurringExpenseSchema = ({list}) => {
    const {
        items: notApplicableList,
        status: notApplicableListStatus,
    } = list.notApplicable;

    const Feq = {...Frequency}
    delete Feq.Yearly
    return (
        {
            transactionType: {
                type: 'select',
                label: 'Expense Type',
                options: notApplicableListStatus === "success" ? notApplicableList : {},
                columns: {sm: 12, md: 6},
                isSearch: true,
                validation: (value) => {
                    if (value === '') return 'Transaction type is required';
                    return null;
                },
            },
            amount: {
                type: 'text',
                label: 'Amount',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (String(value).trim() === '') return 'Amount is required';
                    return null;
                },
            },
            type: {
                type: 'select',
                label: 'Type',
                enums: true,
                options: RecurringType,
                columns: {sm: 12, md: 6},
                validation: (value) => {
                    return null;
                },
            },
            transactionDate: {
                type: 'date',
                label: 'Transaction Date',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (value.trim() === '') return 'Transaction date is required';
                    return null;
                },
            },
            schedules: {
                type: 'object',
                label: 'Schedules',
                properties: {
                    frequency: {
                        type: 'select',
                        label: 'frequency',
                        options: Feq,
                        enums: true,
                        columns: {sm: 12, md: 6},
                    },
                    dayOfMonth: {
                        type: 'text',
                        label: 'Day Of Month',
                        columns: {sm: 12, md: 6},
                        dependsOn: [
                            {field: "schedules.frequency", value: "Monthly"}
                        ],
                        validation: (value, fields) => {
                            if (String(value).trim() === '' && fields.schedules.frequency === Feq.Monthly) return 'Day is required';
                            return null;
                        },
                    }
                }
            },
            endDate: {
                type: 'date',
                label: 'End Date',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    return null;
                },
            },
            description: {
                type: 'textarea',
                label: 'Description',
            },
        }
    )
}

